import React, { Fragment } from "react";
import { connect } from "formik";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import { loanTypeList } from "constants/loanTypes";
import interestRateTypeIds from "constants/interestRateTypes";

import { SectionGrid, StyledAutoCompleteInput, StyledTextInput, StyledPercentInput, PercentContainer } from "../styles";

import FormSectionTitle from "./FormSectionTitle";

const LoanAssumptionsSection = props => {
  const { formik, interestRateTypes, floatingIndices, fixedIndices } = props;
  const { values, handleChange, form, setFieldTouched } = formik;
  if (!interestRateTypes) {
    return null;
  }

  const rateIndexOptions = values.interestRateType && values.interestRateType === interestRateTypeIds.FLOATING ? floatingIndices : fixedIndices;
  const loanTypeListFiltered = loanTypeList.filter(x => x.isAssumptionType);

  return (
    <>
      <Grid item xs={10}><FormSectionTitle title="LOAN ASSUMPTIONS" /></Grid>
      <Grid item xs={10}>
        <StyledAutoCompleteInput
          label="Loan Type"
          fieldName="loanType"
          selectValue="value"
          options={loanTypeListFiltered}
          onChange={e => {
            props.setLoanProceedAssumptions(e, props.formik); setFieldTouched("loanType", true);
          }}
        />
        {" "}
      </Grid>
      <Grid item xs={10}><StyledTextInput label="Term (m)" fieldName="loanTerm" /></Grid>
      <Grid item xs={10}><StyledTextInput label="Amort. Term (m)" fieldName="amortizationTerm" /></Grid>
      <Grid item xs={10}>
        <StyledAutoCompleteInput label="Interest Rate Type" fieldName="interestRateType" selectValue="value" options={interestRateTypes} />
        {" "}
      </Grid>
      <Grid item xs={10}>
        <StyledAutoCompleteInput label="Rate Index" fieldName="rateIndex" selectValue="value" options={rateIndexOptions} />
        {" "}
      </Grid>
      <Grid item xs={10}>
        <StyledPercentInput label="Spread" decimalScale={3} fieldName="spread" />
        {" "}
      </Grid>
      {values.interestRateType === interestRateTypeIds.FLOATING && <Grid item xs={10}><StyledPercentInput label="Underwr. Rate (Floating)" decimalScale={3} fieldName="UwRate" /></Grid>}

    </>
  );
};
export default compose(
  connect
)(LoanAssumptionsSection);
